export default __webpack_public_path__ + "static/media/Spear of the Dark Sun.7f98706b.jpg";